import { useEffect } from 'react'

const META_PIXEL_ID = '939294421933671'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

function loadPixelScript() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = document.getElementsByTagName('script')[0]
  s.parentNode?.insertBefore(t, s)

  // Also add noscript fallback
  const ns = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  ns.appendChild(img)
  document.body.appendChild(ns)
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    if (params) {
      window.fbq('track', eventName, params)
    } else {
      window.fbq('track', eventName)
    }
  }
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()

    // Init and fire PageView
    if (window.fbq) {
      window.fbq('init', META_PIXEL_ID)
      window.fbq('track', 'PageView')
    } else {
      // If script hasn't loaded yet, wait for it
      const checkInterval = setInterval(() => {
        if (window.fbq) {
          window.fbq('init', META_PIXEL_ID)
          window.fbq('track', 'PageView')
          clearInterval(checkInterval)
        }
      }, 100)

      // Clear after 10s to avoid infinite polling
      setTimeout(() => clearInterval(checkInterval), 10000)
    }
  }, [])
}
